import ActivityCard from "components/ActivityPanel/ActivityCard";
import React from "react";
import ProductionCardContent from "./ProductionActivityCardContent";

interface Props {
  activity: server.dto.ProductionActivity
}

const ProductionActivityRowCard = (props: Props) => {
  const { activity } = props;

  return <ActivityCard
    activity={activity}
  >
    <ProductionCardContent activity={activity} />
  </ActivityCard>;
};

export default ProductionActivityRowCard;